module.exports = __webpack_public_path__ + "static/media/40.036bb247.jpg";